"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePaginatedModel = void 0;
var react_1 = require("react");
var react_query_1 = require("@tanstack/react-query");
var react_use_1 = require("react-use");
var toQueryString_1 = require("../util/toQueryString");
var withPagination_1 = require("../hocs/withPagination");
var config_1 = require("../util/config");
var api_1 = require("../util/api");
var usePaginatedModel = function (path, filters, _a) {
    var _b = _a === void 0 ? {} : _a, config = _b.queryConfig, requiresAuth = _b.requiresAuth, itemPath = _b.itemPath;
    var _c = (0, react_1.useContext)(config_1.ChocolatesContext), apiBase = _c.apiBase, auth0Token = _c.authToken;
    var _d = (0, react_1.useState)([path, (filters === null || filters === void 0 ? void 0 : filters.page) || 1, filters]), queryKey = _d[0], setQueryKey = _d[1];
    var queryClient = (0, react_query_1.useQueryClient)();
    var fetcher = (0, react_1.useCallback)(function (path, filters) { return __awaiter(void 0, void 0, void 0, function () {
        var body;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, api_1.request)({
                        apiBase: apiBase,
                        path: path + "?".concat((0, toQueryString_1.toQueryString)(filters)),
                        method: 'get',
                        auth0Token: auth0Token,
                        shouldThrow: true,
                    })];
                case 1:
                    body = (_a.sent()).body;
                    return [2 /*return*/, body];
            }
        });
    }); }, [auth0Token, apiBase]);
    var getModelById = (0, react_1.useCallback)(function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var body;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, api_1.request)({
                        apiBase: apiBase,
                        path: "".concat(itemPath !== null && itemPath !== void 0 ? itemPath : path, "/").concat(id),
                        method: 'get',
                        auth0Token: auth0Token,
                    })];
                case 1:
                    body = (_a.sent()).body;
                    return [2 /*return*/, body];
            }
        });
    }); }, [auth0Token, path, itemPath, apiBase]);
    var isValidRequest = !!path && (!requiresAuth || !!auth0Token);
    (0, react_use_1.useDeepCompareEffect)(function () {
        setQueryKey([path, (filters === null || filters === void 0 ? void 0 : filters.page) || 1, filters]);
    }, [path, filters !== null && filters !== void 0 ? filters : {}]);
    var response = (0, react_query_1.useQuery)(queryKey, function () { return fetcher(path, filters); }, __assign(__assign({ keepPreviousData: true, refetchOnReconnect: false, refetchOnMount: true, refetchOnWindowFocus: false }, config), { enabled: isValidRequest && ((config === null || config === void 0 ? void 0 : config.enabled) || (config === null || config === void 0 ? void 0 : config.enabled) == undefined), initialData: config === null || config === void 0 ? void 0 : config.initialData, placeholderData: {
            metadata: withPagination_1.DEFAULT_METADATA,
            results: [],
        } }));
    var updateData = (0, react_1.useCallback)(function (updater) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, queryClient.setQueryData(queryKey, updater)];
    }); }); }, [queryClient, queryKey]);
    var invalidateData = (0, react_1.useCallback)(function (options) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, queryClient.invalidateQueries(queryKey, {}, options)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [queryClient, queryKey]);
    return __assign(__assign({}, response), { fetcher: fetcher, getModelById: getModelById, invalidateData: invalidateData, updateData: updateData, queryKey: queryKey });
};
exports.usePaginatedModel = usePaginatedModel;
exports.default = exports.usePaginatedModel;
//# sourceMappingURL=usePaginatedModel.js.map